import React from 'react';
import { Dialog } from '@headlessui/react';

export default function NarrationConfirmModal({ isOpen, onCancel, onConfirm, cost = 3, balance = null, isRegenerate = false }) {
  return (
    <Dialog open={isOpen} onClose={onCancel} className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-screen items-center justify-center p-4">
        <Dialog.Overlay className="fixed inset-0 bg-black/40" />

        <div className="relative w-full max-w-sm rounded-lg bg-white p-5 shadow-xl">
          <Dialog.Title className="text-base font-semibold text-gray-900 mb-2">
            {isRegenerate ? 'Regenerate naration?' : 'Generate naration?'}
          </Dialog.Title>
          <Dialog.Description className="text-sm text-gray-600 mb-4">
            This will deduct <span className="font-semibold">{cost} credits</span>
            {balance !== null ? (
              <> from your balance (<span className="font-mono">{balance}</span> remaining).</>
            ) : '.'}
          </Dialog.Description>

          <div className="mt-2 flex items-center justify-end gap-2">
            <button
              type="button"
              className="px-3 py-1.5 text-sm rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
              onClick={onCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="px-3 py-1.5 text-sm rounded-md bg-indigo-600 text-white hover:bg-indigo-700"
              onClick={onConfirm}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
